import React from 'react';

import styles from './AssetListCard.module.css';

type AssetListCardProps = {
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
};

export const AssetListCard: React.FC<AssetListCardProps> = ({ title, children, actions }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};
